export const JourneysPaths = {
    new: "/new",
    edit: ":journeyId",
} as const;
